export default __webpack_public_path__ + "static/media/w4.18a864a9.png";